module.exports = __webpack_public_path__ + "static/media/independent-on-saturday.e3e9da2f.svg";